export const AUTH_ROUTE = 'AUTH_ROUTE';
export const NON_AUTH_ROUTE = 'NON_AUTH_ROUTE';
export const PUBLIC_ROUTE = 'PUBLIC_ROUTE';
